module.exports = __webpack_public_path__ + "img/20.79e28b3f.png";